import React from "react";
import { Badge } from "react-bootstrap";
import { Color } from "react-bootstrap/esm/types";

type StatusBadgeProps={
    text:string,
    bg:string,
    textColor?:Color
}
export default function StatusBadge({text, bg, textColor}:StatusBadgeProps) {
  return (
    <Badge bg={bg} text={textColor??"dark"} className="m-1 px-3 py-2 rounded-pill">
      {text}
    </Badge>
  );
}
